import { render, staticRenderFns } from "./m-header-richmond.vue?vue&type=template&id=081c0a30&scoped=true&"
import script from "./m-header-richmond.vue?vue&type=script&lang=js&"
export * from "./m-header-richmond.vue?vue&type=script&lang=js&"
import style0 from "./m-header-richmond.vue?vue&type=style&index=0&id=081c0a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c0a30",
  null
  
)

export default component.exports